import orderBy from 'lodash.orderby';

import type { AdvanceFilter } from '../../../advance-filters';
import { defaultFilterValues, matchNotMatchTypeValues } from '../../../advance-filters';
import type { SupportFilterSchema } from '../../shared/filters';
import { priorityOptions, supportStatusOptions } from '../../shared/schemas/support-query-schema';

export const advFilters: AdvanceFilter<SupportFilterSchema>[] = orderBy(
  [
    {
      ...defaultFilterValues,
      mainKey: 'status',
      title: 'Status',
      fieldType: 'custom',
      options: supportStatusOptions.map((option) => ({
        ...option,
        name: option.label,
      })),
      types: [...matchNotMatchTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'priority',
      title: 'Priority',
      fieldType: 'custom',
      options: priorityOptions.map((option) => ({
        ...option,
        name: option.label,
      })),
      types: [...matchNotMatchTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'agent',
      title: 'Agent',
      fieldType: 'custom',
      types: [...matchNotMatchTypeValues],
    },
    {
      ...defaultFilterValues,
      mainKey: 'contact',
      title: 'Contact',
      fieldType: 'custom',
      types: [...matchNotMatchTypeValues],
    },
  ],
  'title'
);
